module.exports = {"apiKey":"AIzaSyARc8tGJJsj4ePqvLHKuS4KFcyttTQ2PQs","authDomain":"migrador-f5069.firebaseapp.com","databaseURL":"https://migrador-f5069.firebaseio.com","projectId":"migrador-f5069","storageBucket":"migrador-f5069.appspot.com","messagingSenderId":"657090783636"}


//////////////////
// WEBPACK FOOTER
// ./src/js/firebase/firebase-config.json
// module id = 179
// module chunks = 0